<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('scripts')"
      :columns="columns"
      :column_search="false"
      :searching="false"
      resource_url="/script/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="restart">
          <span class="icon"
            ><i class="fa fa-recycle has-text-success"></i
          ></span>
          <span>{{ $t("restart scheduled") }}</span>
        </button>
      </template>
    </generic-table>
  </div>
  <execute-modal ref="execute_modal" @success="refresh" />
  <scheduled-execution-modal
    ref="scheduled_execution_modal"
    @success="refresh"
  />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  success_message,
  error_message,
  post,
  format_currency,
} from "@/utils";
import ExecuteModal from "./execute_modal/Index.vue";
import ScheduledExecutionModal from "./scheduled_execution_modal/Index.vue";
import cronstrue from "cronstrue";
import { truncate } from "lodash";

export default {
  name: "ScriptDatatable",
  components: { GenericTable, ExecuteModal, ScheduledExecutionModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          width: "40%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            let icon = "code";
            let color = "";
            if (row.language == "nodejs") {
              icon = "js";
              color = "has-text-warning";
            }
            if (row.language == "python") {
              icon = "python";
              color = "has-text-info";
            }
            return `<div class="title is-6">
                      <span class="icon ${color}" data-tooltip="${row.language}">
                        <i class="icon ${icon}"></i>
                      </span> ${row.name}
                    </div>
                    <div class="subtitle is-6">${row.description}</div>`;
          },
        },
        // {
        //   title: v.$t("description"),
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     return row.description || "";
        //   },
        // },
        {
          title: v.$t("scheduled execution"),
          data: (row) => {
            if (row.scheduled) {
              try {
                let struct = `<div class="title is-6">
                          <span class="icon has-text-primary">
                            <i class="fa fa-check"></i>
                          </span> ${cronstrue.toString(row.scheduled.schedule)}
                        </div>
                        <div class="subtitle is-6 mb-0">${
                          row.scheduled.schedule
                        }</div>`;

                let btn = {};
                let is_running = row.task ? row.task.is_running : undefined;
                if (is_running) {
                  btn = {
                    args: { uuid: row.uuid },
                    tooltip: v.$t("stop"),
                    icon: "fa fa-stop",
                    icon_class: "is-small has-text-danger",
                    click: function (e) {
                      // console.log("edit order", e.detail.uuid);
                      post("/script/stop", { directory: row.directory })
                        .then(() => {
                          success_message(v.$t("task stopped"));
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    },
                  };
                } else {
                  btn = {
                    args: { uuid: row.uuid },
                    tooltip: v.$t("start"),
                    icon: "fa fa-play",
                    icon_class: "is-small has-text-success",
                    click: function (e) {
                      // console.log("edit order", e.detail.uuid);
                      post("/script/start", { directory: row.directory })
                        .then(() => {
                          success_message(v.$t("task started"));
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    },
                  };
                }

                let btns = generate_datatables_buttons([btn]);
                return `${struct} ${btns}`;
              } catch (error) {
                console.log(error);
              }
            } else
              return `<span class="icon has-text-warning">
                        <i class="fa fa-ban"></i>
                      </span> ${v.$t("not scheduled")}`;

            // return args.map((arg) => arg.name).join(", ");
          },
        },
        {
          title: v.$t("arguments"),
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            let args = row.arguments || [];
            let r = args.map((arg) => arg.name).join(", ");
            return truncate(r, { length: 50 });
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("execute"),
                icon: "fa fa-bolt",
                icon_class: "is-small has-text-primary",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.execute_modal.show_modal(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("log"),
                icon: "fa fa-file-text",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$router.push({ path: `/script/log/${row.directory}` });
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("scheduled execution"),
                icon: "fa fa-clock-o",
                icon_class: "is-small has-text-warning",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.scheduled_execution_modal.show_modal(row);
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    restart() {
      let v = this;
      post("/script/restart")
        .then(() => {
          success_message(v.$t("scheduled scripts restarted"));
        })
        .catch((error) => {
          error_message(error);
        });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
